import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import useLogAcessoManual from "~fetchs/useLogAcessoManual";

const ModalSyncContext = createContext(null);

export const ModalSyncProvider = ({ children }) => {
  const [showModalSync, setShowModalSync] = useState(false);
  const [lastFetch, setLastFetch] = useState(() => localStorage.getItem("last-fetch-datetime-new"));
  const [loading, setLoading] = useState(false);

  const { logarAcesso, isAdmin } = useLogAcessoManual();

  const location = useLocation();

  useEffect(() => {
    const handleLastFetchUpdate = () => {
      const stored = localStorage.getItem("last-fetch-datetime-new");
      setLastFetch(stored || null);
    };

    globalThis.addEventListener("last-fetch-updated", handleLastFetchUpdate);
    return () => globalThis.removeEventListener("last-fetch-updated", handleLastFetchUpdate);
  }, []);

  useEffect(() => {
    const handler = (e) => setLoading(e.detail.loading);
    window.addEventListener("sync-loading-changed", handler);
    return () => window.removeEventListener("sync-loading-changed", handler);
  }, []);

  const isSameDay = () => {
    if (!lastFetch) return false;
    const lastSync = new Date(lastFetch);
    return lastSync.toDateString() === new Date().toDateString();
  };

  const isAfterTime = (date, targetHour, targetMinute) => {
    const minutes = date.getHours() * 60 + date.getMinutes();
    const target = targetHour * 60 + targetMinute;

    return minutes >= target;
  }

  const handleClose = useCallback(() => {
    localStorage.setItem("pageCount", 0);
    logarAcesso("Usuario não sincronizou após as 5:30h");
    setShowModalSync(false);
  }, [logarAcesso]);

  const handleSync = useCallback(() => {
    const now = new Date().toISOString();
    localStorage.setItem("last-fetch-datetime-new", now);
    setLastFetch(now);

    localStorage.setItem("pageCount", 0);
    localStorage.setItem("shouldSyncronize", "true");

    setShowModalSync(false);
    window.location.reload();
  }, []);

  useEffect(() => {
    if (loading) return;

    if (!lastFetch) {
      if (!isAdmin) setShowModalSync(true);
      return;
    }

    const lastSync = new Date(lastFetch);
    const syncedToday = lastSync.toDateString() === new Date().toDateString();
    if (syncedToday && isAfterTime(lastSync, 5, 30)) {
      setShowModalSync(false);
      return;
    }
    if (!isAfterTime(new Date(), 5, 30)) {
      setShowModalSync(false);
    }
  }, [lastFetch, loading, isAdmin]);

  useEffect(() => {

    if (isSameDay()) {
      const lastSync = new Date(lastFetch);
      const currentDate = new Date();

      if ((isAfterTime(lastSync, 5, 30)) || !isAfterTime(currentDate, 5, 30)) return;
    }

    let count = Number(localStorage.getItem("pageCount") || 0);
    count += 1;
    localStorage.setItem("pageCount", count);

    if (count > 0 && count % 3 === 0) {
      if (!isAdmin) setShowModalSync(true);
    }

    localStorage.setItem("previousPath", location.pathname);
  }, [location.pathname, isAdmin]);

  const contextValue = useMemo(
    () => ({ handleSync, handleClose, showModalSync, setShowModalSync }),
    [handleSync, handleClose, showModalSync]
  );

  return (
    <ModalSyncContext.Provider value={contextValue}>
      {children}
    </ModalSyncContext.Provider>
  );
};

export const useModalSyncContext = () => {
  const context = useContext(ModalSyncContext);
  if (!context)
    throw new Error("useModalSyncContext deve ser usado dentro de um ModalSyncProvider");
  return context;
};

export default ModalSyncContext;
